export default {
  addEventStateAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addEventState", payload)
      resolve()
    })
  }
}
